import React from 'react';

const LEVEL_COLORS = {
  NOMINAL: '#00E5FF',
  ELEVATED: '#FF9F0A',
  STORM: '#FF6B35',
  EXTREME: '#FF3B30',
};

export default function EventTimelineRail({ insights, selectedInsightId, onSelectInsight }) {
  if (!insights || insights.length === 0) return null;

  // Take top 8 most recent/severe
  const items = insights.slice(0, 8);

  return (
    <div className="orion-timeline" data-testid="event-timeline-rail">
      <div className="orion-gauge-header">
        <span className="orion-gauge-title">RECENT EVENTS</span>
        <span style={{ fontSize: '8px', fontFamily: 'var(--o-mono)', color: '#52525B' }}>{items.length}</span>
      </div>
      <div className="orion-timeline-list">
        {items.map(ins => {
          const color = LEVEL_COLORS[ins.alert] || '#00E5FF';
          const isActive = ins.id === selectedInsightId;
          return (
            <div
              key={ins.id}
              className={`orion-tl-item ${isActive ? 'active' : ''}`}
              onClick={() => onSelectInsight(ins.id)}
              data-testid={`timeline-item-${ins.id}`}
            >
              <div className="orion-tl-dot" style={{ background: color }} />
              <div className="orion-tl-content">
                <div className="orion-tl-topic">{ins.topic?.substring(0, 50)}</div>
                <div className="orion-tl-meta">
                  <span style={{ color }}>{ins.alert}</span>
                  <span>{ins.sources?.[0]}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
